// extracted by mini-css-extract-plugin
module.exports = {"checkboxList":"CheckboxList_checkboxList__3ctpA","checkboxContainer":"CheckboxList_checkboxContainer___GubN"};